const React = require('react')
const { Container, Row, Col } = require('reactstrap')

const { SearchAndBanner } = require('./searchAndBanner.home')
const { GeneralInfo } = require('./generalInfo.home')
const { LatestTable } = require('./latestTable.home')

require('@styles/pages/home/index.css')

const Home = props => {
    return (
        <div className='page'>
            <Container>
                <SearchAndBanner />
                <GeneralInfo />
                <div className='general-info'>
                    <Row>
                        <Col>
                            <Container fluid className='p-0'>
                                <Row className='mx-0'>
                                    <Col className='network-table' lg='6'>
                                        <LatestTable tableTitle='Blocks' tableType='blocks' />
                                    </Col>
                                    <Col className='network-table' lg='6'>
                                        <LatestTable tableTitle='Transactions' tableType='txs' />
                                    </Col>
                                </Row>
                            </Container>
                        </Col>
                    </Row>
                </div>
            </Container>
        </div>
    )
}

module.exports = React.memo(Home)
